(function () {
	const iframeActionUrl = document.currentScript.dataset.iframeActionUrl;

	window.iFrameResizer = {
		readyCallback: function () {
			window.parentIFrame.sendMessage(iframeActionUrl);
		},
	};
})();
